import { useEffect } from 'react'
import {
  holidayData,
  kepkoTou,
  seasonMapping,
  touPeriods,
} from '../util/algorithm/fakeRatesData'
import { timeData } from '../util/algorithm/fakeLoadData'
import { calLoadTimeSum } from '../util/algorithm/classifyTimeData'
import {
  ISeasonalNumMulNum,
  ISeasonalNumPlusISeasonalNum,
  calReduceCharge,
  calSeasonalExCharge,
  subtractPrevProfitToTradingCharge,
} from '../util/algorithm/calExCharge'
import { calKepcoAverage } from '../util/algorithm/kepcoTOU'
import { calMinChargeUnit, calTouUnitCharge } from '../util/algorithm/makeTOU'
import {
  calSeasonalSum,
  monthLoadTimeToSeasonLoadTime,
} from '../util/algorithm/monthToSeason'
import {
  calMonthCharge,
  calSeasonLoadTimeToSum,
} from '../util/algorithm/calCharge'

const AlgoTestSell = () => {
  useEffect(() => {
    //---------------
    // 0. 고객정보
    const prevKEPCOContractedPower = 400
    // const
    // 1. 한전요금제 고르기
    const kepcoTOUList = [kepkoTou]
    const kepcoTouAverRate = calKepcoAverage(kepcoTOUList)
    console.log('한전요금제 평균', kepcoTouAverRate)
    const kepcoTOU = [kepkoTou][0]

    const tmpSeasonMapping = seasonMapping
    // 2. 공휴일 고르기
    // 2-5 공휴일 고르기
    const tmpHolidayData = holidayData
    // 3. 기후환경요금 단가
    const environmentalUnit = 0.1

    // 4. 부하 고르기
    // 원본 데이터일 경우
    const loadData = timeData
    const seasonSum = calSeasonalSum(timeData, tmpSeasonMapping)
    console.log('계절별 사용량 합', seasonSum)

    // 평균값일 경우

    // 계절별 전력거래 합 구하기
    const seasonalLoadSum = calSeasonalSum(loadData, tmpSeasonMapping)
    console.log('계절별 전력거래 합', seasonalLoadSum)

    // const seasonalEnvCharge = calSeasonalExCharge(0.1034, seasonalLoadSum)
    // console.log('전력시장 거래 수수료 단가', seasonalEnvCharge)

    // 한전에 내던 기존 요금 구하기

    // 부하 합 계산
    const kepcoMonthCharge = calLoadTimeSum(
      loadData,
      tmpSeasonMapping,
      tmpHolidayData,
      touPeriods
    ).loadTimeSumResult
    console.log('부하합', kepcoMonthCharge)

    // 계절별 부하별 요금
    const kepcoSeasonLoadTimeCharge = monthLoadTimeToSeasonLoadTime(
      kepcoMonthCharge,
      tmpSeasonMapping
    )
    console.log('계절별 부하별 요금', kepcoSeasonLoadTimeCharge)

    //계절별 요금
    const kepcoSeasonCharge = calSeasonLoadTimeToSum(kepcoSeasonLoadTimeCharge)
    console.log('계절별 요금', kepcoSeasonCharge)

    // 5. 구매비용 계산
    // 5-1. 계절별 구매 비용 계산
    // 목록에서 계산 / 돌면서 합 계산
    // TODO: 좀만 이따 하자
    const buyPrice = { spr: 10000, sum: 10000, fall: 10000, win: 10000 }

    // 6. 전력구매비율
    const essPowerRate = 0.5
    // 7. 변경될 한전과의 계약전력
    const afterKEPCOContractedPower = 200
    // 예상 절감비용 계산
    const expectReduceCharge = calReduceCharge(
      kepcoTOU.defaultChargeUnit,
      environmentalUnit,
      prevKEPCOContractedPower,
      afterKEPCOContractedPower,
      seasonSum,
      tmpSeasonMapping
    )
    console.log('예상절감비용', expectReduceCharge)

    // 8. 가격비율
    // 1. 한전 요금제 비율일 경우
    let touRate = kepcoTouAverRate

    console.log('가격비율', touRate)
    // 시간대
    let touPeriod = touPeriods
    // 9. 망 이용요금
    const seasonalGridUsageCharge = calSeasonalExCharge(100, seasonSum)
    console.log('망 이용요금', seasonalGridUsageCharge)

    // 10. 이익 가중치 비율 계산
    const essProfitRate = 0.8

    // const seasonalProfit = calSeasonalProfit()

    // 11. 계절별 최대(기존 한전 요금 kepcoSeasonCharge) - 최소(구매비용+망이용요금)로 전체 이익 구하기
    const seasonalMin = ISeasonalNumPlusISeasonalNum(
      buyPrice,
      seasonalGridUsageCharge
    )
    const totalProfit = subtractPrevProfitToTradingCharge(
      kepcoSeasonCharge,
      seasonalMin
    )

    // 12. 전체 이익*수용가 비중 으로 x 구하기 calMinChargeUnit
    const x = ISeasonalNumMulNum(totalProfit, essProfitRate)

    const seasonalMinChargeUnit = calMinChargeUnit(
      touRate,
      kepcoSeasonLoadTimeCharge,
      x
    )

    console.log('계절별 최소요금', seasonalMinChargeUnit)

    // 13. 단가랑 비율로 요금제 단가 계산하기 calTouUnitCharge
    const touUnit = calTouUnitCharge(touRate, seasonalMinChargeUnit)

    console.log('계절별 요금제 단가', touUnit)

    // 14. 변경후 요금 계산 monthLoadTimeToSeasonLoadTime
    const afterCharge = monthLoadTimeToSeasonLoadTime(
      calMonthCharge(kepcoMonthCharge, touUnit, seasonMapping),
      seasonMapping
    )

    console.log('변경 후 요금', afterCharge)
  }, [])
  return <div></div>
}

export default AlgoTestSell
